import { UI_PRIMITIVE__checkbox } from '@/components/ui/UI_PRIMITIVE__checkbox';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_ml_asset } from '@/hooks/store/use_slices';
import i18n_page_diffusion_models from '@/locales/keys/i18n_page_diffusion_models.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { local_ml_asset_set_current_table_page_settings } from '@/state/diffusion_models_ud/local_ml_asset_set_current_table_page_settings';
import { useTranslation } from 'react-i18next';

export function DiffusionModelsCheckboxShowOnlyUsedUD() {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_DIFFUSION_MODELS);

  const dispatch = use_dispatch();

  const { current_table_page_settings } = use_slice_ml_asset(['current_table_page_settings']);

  /*
   * EVENTS
   */

  async function onClick() {
    let current_table_page_settings_new = current_table_page_settings.clone({ filter_show_only_used: !current_table_page_settings.filter_show_only_used });

    dispatch(local_ml_asset_set_current_table_page_settings(current_table_page_settings_new));
  }

  /*
   * HTML
   */
  return (
    <div className="flex items-center justify-between my-2 w-full px-2 cursor-pointer" onClick={onClick}>
      <label className={`ml-2 text-sm cursor-pointer`}>{t(i18n_page_diffusion_models.checkbox.show_only_used)}</label>
      <UI_PRIMITIVE__checkbox checked={current_table_page_settings.filter_show_only_used} />
    </div>
  );
}
